import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ChatTab.css";
import { getBookingChatCountAPI } from "../../../utils/APIs/chatApis";
import Loader from "../../../Loader/Loader";

const ChatTab = () => {
  const navigate = useNavigate();

  const [bookings, setBookings] = useState([]);
  const [page, setPage] = useState(1);
const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
const LIMIT = 10;

const fetchBookingChats = useCallback(
  async (pageNumber = page) => {
  try {
    setLoading(true);

    const res = await getBookingChatCountAPI(pageNumber, LIMIT);

    if (res?.data?.success) {
      setBookings(res.data.data || []);
      setTotal(res.data.meta?.total || 0);
      setPage(res.data.meta?.page || pageNumber);
    }
  } catch (error) {
    console.error("Failed to fetch booking chats", error);
  } finally {
    setLoading(false);
  }
    }, [page] // dependency
);

useEffect(() => {
  fetchBookingChats();

  const interval = setInterval(() => {
    fetchBookingChats();
  }, 10000);

  return () => clearInterval(interval);
}, [fetchBookingChats]);

  const handleChatClick = (booking) => {
    console.log("bookingId", booking.bookingId);

    // use id for chat messages API
    navigate(`/chat/booking/${booking.id}`);
  };

  const totalPages = Math.ceil(total / LIMIT);

const getPageNumbers = () => {
  const pages = [];
  const maxVisible = 3;

  let start = Math.max(1, page - 2);
  let end = Math.min(totalPages, page + 2);

  if (end - start < maxVisible - 1) {
    if (start === 1) {
      end = Math.min(totalPages, start + maxVisible - 1);
    } else if (end === totalPages) {
      start = Math.max(1, end - maxVisible + 1);
    }
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return pages;
};

  return (
    <div className="table-wrapper">
      <table className="bookings-table">
        <thead>
          <tr>
            <th className="td-sr">Sr.</th>
            <th>Booking ID</th>
            <th>Client Name</th>
            <th>Event Type</th>
            <th>Event Location</th>
            <th>Booking Amount</th>
            <th>Payment Mode</th>
            <th>Booking Status</th>
            <th>Payment Status</th>
            <th>Chat</th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan="10" className="no-data">
                <Loader/>
              </td>
            </tr>
          ) : bookings.length === 0 ? (
            <tr>
              <td colSpan="10" className="no-data">
                No bookings found
              </td>
            </tr>
          ) : (
            bookings.map((item, index) => (
              <tr key={item.id}>
                 <td className="td-sr">{(page - 1) * LIMIT + index + 1}</td>
                <td>{item.bookingId || "-"}</td>

                <td>{item.clientName || "-"}</td>

                <td>{item.eventType || "-"}</td>

                <td>{item.eventLocation || "-"}</td>

                <td>₹ {item.bookingAmount || "-"}</td>

                <td>{item.paymentMode || "-"}</td>

                <td>
                  <span className={`status ${item.bookingStatus}`}>
                    {item.bookingStatus || "-"}
                  </span>
                </td>

                <td>
                  <span className={`status ${item.paymentStatus}`}>
                    {item.paymentStatus || "-"}
                  </span>
                </td>

                <td>
                  <div
                    className="chat-btn chat-icon-wrapper"
                    onClick={() => handleChatClick(item)}
                  >
                    💬

                    {item.unreadmessages > 0 && (
                      <span className="chat-badge">
                        {item.unreadmessages}
                      </span>
                    )}
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {total > LIMIT && (
  <div className="pagination">
    {/* Prev */}
    <button
      className="pagination-btn"
      disabled={page === 1}
      onClick={() => setPage(page - 1)}
    >
      Prev
    </button>

    {/* Page Numbers */}
    {getPageNumbers().map((p) => (
      <button
        key={p}
        className={`pagination-btn ${p === page ? "active" : ""}`}
        onClick={() => setPage(p)}
      >
        {p}
      </button>
    ))}

    {/* Next */}
    <button
      className="pagination-btn"
      disabled={page === totalPages}
      onClick={() => setPage(page + 1)}
    >
      Next
    </button>
  </div>
)}
    </div>
  );
};

export default ChatTab;

// import React from 'react'
// import { useNavigate } from 'react-router-dom';
// import "./ChatTab.css"
// const ChatTab = () => {

//     const navigate = useNavigate();

//     const dummyData = [
//         {
//             shootId: 1,
//             shoot_id: "BK-1001",
//             client_id: "CL-01",
//             client_name: "Rahul Sharma",
//             shoot_type: "Wedding",
//             event_date: "2026-02-10",
//             event_location: "Delhi",
//             booking_amount: 50000,
//             payment_mode: "UPI",
//             payment_type: "Advance",
//             status: "Confirmed",
//             payment_status: "Paid",
//             assigned_photographer: "Amit",
//             team_studio: "Dream Studio",
//             notes: "Evening event",
//             chat_count:6
//         },
//         {
//             shootId: 2,
//             shoot_id: "BK-1002",
//             client_id: "CL-02",
//             client_name: "Priya Verma",
//             shoot_type: "Pre-Wedding",
//             event_date: "2026-03-05",
//             event_location: "Jaipur",
//             booking_amount: 30000,
//             payment_mode: "Cash",
//             payment_type: "Full",
//             status: "Pending",
//             payment_status: "Unpaid",
//             assigned_photographer: "Rohit",
//             team_studio: "Lens Craft",
//             notes: "",
//              chat_count:1
//         },
//     ];


//     const handleChatClick = (booking) => {
//         console.log("shootId", booking.shoot_id)
//         navigate(`/chat/booking/${booking.shoot_id}`);
//     };


//     return (
//         <div className="table-wrapper">

//             <table className="bookings-table">
//                 <thead>
//                     <tr>
//                         <th>Sr.</th>
//                         <th>Booking ID</th>
//                         <th>Client Name</th>
//                         <th>Event Type</th>
//                         <th>Event Date</th>
//                         <th>Event Location</th>
//                         <th>Booking Amount</th>
//                         <th>Payment Mode</th>
//                         {/* <th>Payment Type</th> */}
//                         <th>Booking Status</th>
//                         <th>Payment Status</th>
//                         <th>Assigned Photographer</th>
//                         <th>Team / Studio</th>
//                         <th>Chat</th>

//                     </tr>
//                 </thead>

//                 <tbody>
//                     {dummyData.length === 0 ? (
//                         <tr>
//                             <td colSpan="15" className="no-data">
//                                 No bookings found
//                             </td>
//                         </tr>
//                     ) : (
//                         dummyData.map((item, index) => (
//                             <tr key={item.shootId}>
//                                 {/* Sr */}
//                                 {/* <td>{(page - 1) * limit + index + 1}</td> */}
//                                 <td>{index + 1}</td>
//                                 {/* Booking ID */}
//                                 <td>{item.shoot_id || "-"}</td>

//                                 {/* Client Name */}
//                                 <td>{item.client_name || "-"}</td>

//                                 {/* Event Type */}
//                                 <td>{item.shoot_type || "-"}</td>

//                                 {/* Event Date */}
//                                 <td>{item.event_date || "-"}</td>

//                                 {/* Event Location */}
//                                 <td>{item.event_location || "-"}</td>

//                                 {/* Booking Amount */}
//                                 <td>₹ {item.booking_amount || "-"}</td>

//                                 {/* Payment Mode */}
//                                 <td>{item.payment_mode || "-"}</td>

//                                 {/* Payment Type */}
//                                 {/* <td>{item.payment_type || "-"}</td> */}

//                                 {/* Booking Status */}
//                                 <td>
//                                     <span className={`status ${item.status}`}>
//                                         {item.status || "-"}
//                                     </span>
//                                 </td>

//                                 {/* Payment Status */}
//                                 <td>
//                                     <span className={`status ${item.payment_status}`}>
//                                         {item.payment_status || "-"}
//                                     </span>
//                                 </td>

//                                 {/* Assigned Photographer */}
//                                 <td>{item.assigned_photographer || "-"}</td>

//                                 {/* Team / Studio */}
//                                 <td>{item.team_studio || "-"}</td>

//                                 {/* Chat */}
//                                 <td>
//                                     <div
//                                         className="chat-btn chat-icon-wrapper"
//                                         onClick={() => handleChatClick(item)}
//                                     >
//                                         💬

//                                         {item.chat_count > 0 && (
//                                             <span className="chat-badge">
//                                                 {item.chat_count}
//                                             </span>
//                                         )}


//                                     </div>
//                                 </td>




//                             </tr>
//                         ))
//                     )}
//                 </tbody>

//             </table>


//         </div>
//     );
// }

// export default ChatTab